import { Chart } from 'react-chartjs-2';
import 'chart.js/auto';

export default function Charts(props) {
	const { data, type, options } = props;

	return (
		<>
			<Chart type={type} data={data} options={options} />
		</>
	);
}
